import React from 'react';
import styles from './PaymentMethods.module.css';
import Card from '../../assets/images/card.png'
import  QR from '../../assets/images/qr.png'
import  Erip from '../../assets/images/erip.png'

export type PaymentMethod = 'card' | 'qr' | 'erip';

type Props = {
    value: PaymentMethod;
    onChange: (m: PaymentMethod) => void;
}

const PaymentMethods: React.FC<Props> = ({value, onChange}) => {

    return (
        <section className={styles['paymentMethods-section']} >
        <div className={styles['paymentMethods-container']}>
        <div className={styles['paymentMethods-content']}>
            <h2 className={styles['paymentMethods-title']}>
              Выберите способ оплаты:
            </h2>
            <div className={styles['paymentMethods-cards']} role="radiogroup">
                <button type="button" role="radio" aria-checked={value === 'card'} className={`${styles['paymentsMethods-card']} ${value==='card' ? styles['active'] : ''}`} onClick={() => onChange('card')}>
                    <img src={Card} alt="card" />
                </button>
                <button type="button" role="radio" aria-checked={value === 'qr'} className={`${styles['paymentsMethods-card']} ${value==='qr' ? styles['active'] : ''}`} onClick={() => onChange('qr')}>
                    <img src={QR} alt="qr" />
                </button>
                <button type="button" role="radio" aria-checked={value === 'erip'} className={`${styles['paymentsMethods-card']} ${value==='erip' ? styles['active'] : ''}`} onClick={() => onChange('erip')}>
                    <img src={Erip} alt="erip" />
                </button>
            </div>
        </div>
        </div>
        </section>
    );
};

export default PaymentMethods;